import { Variant } from 'react-bootstrap/esm/types';

import { OrderStatusEnum } from 'src/models/GalenData/Order.model';

export const orderStatusConfig: Record<OrderStatusEnum, { color: Variant }> = {
  [OrderStatusEnum.OPEN]: { color: 'success' },
  [OrderStatusEnum.PENDING]: { color: 'info' },
  [OrderStatusEnum.COMPLETE]: { color: 'primary' },
  [OrderStatusEnum.CLOSED]: { color: 'warning' },
  [OrderStatusEnum.EXPIRED]: { color: 'danger' },
  [OrderStatusEnum.REVIEW]: { color: 'secondary' },
  [OrderStatusEnum.CANCELLED]: { color: 'warning' },
};
